import { Injectable } from '@angular/core';
import { LayoutService } from '../components/app-layout/services/layout.service';
import { TypeBaseineSimulation } from '../models/global.model';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  get resource(): any {
    let str = sessionStorage.getItem('content');
    if (str != null)
      return JSON.parse(str);
    else
      return null;
  }
  set loggednUser(value: any) {
    sessionStorage.setItem(btoa('loggednUser'), btoa(JSON.stringify(value)));
  }

  get loggednUser(): any {
    let str = sessionStorage.getItem(btoa('loggednUser'));
    if (str != null)
      return JSON.parse(atob(str));
    else
      return null;
  }


  set language(value: any) {
    sessionStorage.setItem(('language'), (JSON.stringify(value)));
  }

  get language(): any {
    let str = sessionStorage.getItem(('language'));
    if (str != null)
      return JSON.parse((str));
    else
      return null;
  }
  set resource(value: any) {
    sessionStorage.setItem('content', JSON.stringify(value));
  }

  //#region Logged-in User data.
  get userId(): any {
    const str = sessionStorage.getItem(btoa('userId'));
    return (str == null ? "" : atob(str));
  }
  set userId(value: any) {
    sessionStorage.setItem(btoa('userId'), btoa(`${value}`));
  }

  get userEmail(): any {
    const str = sessionStorage.getItem(btoa('userEmail'));
    return (str == null ? "" : atob(str));
  }
  set userEmail(value: any) {
    sessionStorage.setItem(btoa('userEmail'), btoa(`${value}`));
  }

  get tenantId(): number {
    return Number(sessionStorage.getItem('tenantId'));
  }
  set tenantId(value: number) {
    sessionStorage.setItem('tenantId', `${value}`);
  }

  get selectedType(): TypeBaseineSimulation {
    const str = sessionStorage.getItem(btoa('SELECTED_TYPE'));
    return (str == null ? new TypeBaseineSimulation() : JSON.parse(atob(str)));
  }

  set selectedType(val: TypeBaseineSimulation) {
    sessionStorage.setItem(btoa('SELECTED_TYPE'), btoa(JSON.stringify(val)));
  }

  get selectedChannelId(): number {
    const str = sessionStorage.getItem(btoa('selectedChannelId'));
    return (str == null ? 0 : Number(atob(str)));
  }
  set selectedChannelId(value: number) {
    sessionStorage.setItem(btoa('selectedChannelId'), btoa(`${value}`));
  }

  get selectedRouteId(): number {
    const str = sessionStorage.getItem(btoa('selectedRouteTypeId'));
    return (str == null ? 0 : Number(atob(str)));
  }
  set selectedRouteId(value: number) {
    sessionStorage.setItem(btoa('selectedRouteTypeId'), btoa(`${value}`));
  }

  // set selectedType(value: TypeBaseineSimulation) {
  //   localStorage.setItem('selectedType', JSON.stringify(value));
  // }


  // BELOW CODE TO HAVE VALIDATION IF
  // TYPE IS BASELINE THEN TYPE ID ELSE
  // selectedType.BASELINE.BAESLINEID
  get baseLineId(): number {
    return this.selectedType.baselineId;
  }

  // BELOW CODE TO HAVE VALIDATION IF
  // TYPE IS SIMULATION THEN TYPE ID ELSE NULL
  get simulationId(): number {
    return this.selectedType.simulationId;
  }

  get totalSimulation(): number {
    return Number(sessionStorage.getItem('totalSimulation'));
  }
  set totalSimulation(value: number) {
    sessionStorage.setItem('totalSimulation', `${value}`);
  }

  get totalBaseLine(): number {
    return Number(sessionStorage.getItem('totalBaseLine'));
  }

  set totalBaseLine(value: number) {
    sessionStorage.setItem('totalBaseLine', `${value}`);
  }

  saveToken(token: string): void {
    localStorage.setItem('jwtToken', token);
  }

  getToken(token: string): string | null {
    return localStorage.getItem(token);
  }

  removeToken(key: string): void {
    localStorage.removeItem(key);
  }
  //#endregion Logged-in User data.
}
